<template>
    <div class="brandListWrap11">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item label="品牌商总数">
                        共 {{customerTotal}}位
                    </el-form-item>
                    <el-form-item style="width: 250px;">
                        <el-input  style="width: 250px;" placeholder="注册手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-button type="primary" @click="inviteBrand" v-if="function_inviteBrand">邀请品牌商</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
                       <el-button type="primary" @click="downLoadExcel(3)">下载列表</el-button>
                    </el-form-item> -->
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="35">
                </el-table-column>
                <el-table-column label="序号" width="40">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="公司名称">
                    <template slot-scope="scope">{{ scope.row.companyName }}</template>
                </el-table-column>
                <el-table-column label="注册手机号">
                    <template slot-scope="scope">{{ scope.row.phone }}</template>
                </el-table-column>
                <el-table-column label="接受邀约时间">
                    <template slot-scope="scope">{{ scope.row.submitTime }}</template>
                </el-table-column>
                <el-table-column label="最近登陆时间">
                    <template slot-scope="scope">{{ scope.row.loginTime }}</template>
                </el-table-column>
                <el-table-column label="身份">
                    <template slot-scope="scope">{{ scope.row.userType |turnValToText('user_type') }}</template>
                </el-table-column>
                <el-table-column label="身份状态">
                    <template slot-scope="scope" >
                        <span :class="{grey:scope.row.authResult=='never',red:scope.row.authResult=='p',green:scope.row.authResult=='y',orange_lighter:scope.row.authResult=='n'}">
                            {{ scope.row.authResult|turnValToText('auth_result') }}

                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="公司所在地">
                    <template slot-scope="scope">{{ scope.row.regionName }}</template>
                </el-table-column>
                <el-table-column label="品牌">
                    <template slot-scope="scope">{{ scope.row.brandName }}</template>
                </el-table-column>
                
                <el-table-column label="操作"  width="130">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isLoading:false,
                tableData:[],
                formObj:{
                    fuzzyQuery:'',
                    userType:'',
                    authResult:'',
                    systemResult:'',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total:0,
                customerTotal:'',
                conferenceId:'',
            }
        },
        components: {
        },
        computed: {
            function_inviteBrand(){
                return utils.getCurrentFunction().indexOf("inviteBrand")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            adminId(){
                return utils.getAdminId()
            }
            
        },
        methods: {
            inviteBrand(){
              let _this=this
              this.$router.push({name: 'activeInnerBrandInvite',params: { conferenceId:_this.conferenceId}})
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
            },
            downLoadExcel(type){
                let _this=this
                let arg={
                    userId:_this.adminId,
                    conferenceId:_this.conferenceId,
                    type:type
                }
                ajaxPost('/file/exportHttp', arg).then(function(res) {
                    console.log(res)
                    if(res.errorCode==200){
                        _this.$message("下载成功")  

                        let url=res.data
                        window.location.href= _this.IMG_PREV+url
                        
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    authResult: this.formObj.authResult,
                    userType: this.formObj.userType,
                    systemResult:this.formObj.systemResult,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                let arg=JSON.parse(JSON.stringify(_this.searchObj)) 
                arg.conferenceId=_this.conferenceId
                ajaxPost('/admin/getbrandList', arg).then(function(res) {
                    _this.tableData=res.data.reviewList?res.data.reviewList:[]
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                }, function(res) {
                
                })
            },
            toDetail(list) {
                let userId=list.inviteUserId
                this.$router.push({name: 'activeInnerBrandDetail',params: { userId:userId }})
            },
        },
        mounted(){
            this.getParams()
           this.getTableLists()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .brandListWrap11 {
      background: #fff;
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem; padding-top:0;
       }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/brand.vue